import { render, staticRenderFns } from "./NiceBool.vue?vue&type=template&id=2485ec5a"
import script from "./NiceBool.vue?vue&type=script&lang=js"
export * from "./NiceBool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports